import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import LogoContact from "../logoContact/logoContact";
import Newnavbar from "../newNavbar/Newnavbar";
import Footer from "../footer/Footer";
import "./notFound.css";

/**
 * Real 404 page.
 *
 * Replaces `<Route path="*" element={<Navigate to='/' />} />`, which redirected
 * every unknown URL to the homepage. That pattern produces a "soft 404": the
 * server answers 200 with homepage content, so Google indexes an unbounded
 * number of junk URLs as duplicates of the homepage and reports them under
 * "Soft 404" in Search Console. A mistyped or stale inbound link also gave the
 * visitor no indication that anything was wrong.
 *
 * The matching HTTP 404 status comes from the ErrorDocument directive in
 * public/.htaccess -- a client-side router cannot set a status code itself.
 */
export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Nayak’s Tutorials</title>
        <meta
          name="description"
          content="The page you requested could not be found. Browse our coaching programmes, centres or contact the Nayak’s Tutorials team."
        />
        {/* Must never be indexed, but its links should still be followed. */}
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <LogoContact />
      <Newnavbar />

      <main className="notFoundMain">
        <div className="notFoundInner">
          <p className="notFoundCode">404</p>
          <h1 className="notFoundHeading">This page could not be found</h1>
          <p className="notFoundText">
            The page you are looking for may have been moved, renamed, or no
            longer exists. Here are some places you might be looking for.
          </p>

          <nav aria-label="Helpful links" className="notFoundLinks">
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/8th-9th-10th-cbse-icse-ssc-coaching-classes">
                  Std 8, 9 &amp; 10 coaching (CBSE, ICSE, SSC)
                </Link>
              </li>
              <li>
                <Link to="/11th-12th-science-coaching-classes-in-thane">
                  XI–XII Science coaching
                </Link>
              </li>
              <li>
                <Link to="/neet-coaching-classes-in-thane">
                  NEET-UG coaching in Thane
                </Link>
              </li>
              <li>
                <Link to="/iit-jee-classes-in-thane">
                  IIT-JEE coaching in Thane
                </Link>
              </li>
              <li>
                <Link to="/centers">Our coaching centres</Link>
              </li>
              <li>
                <Link to="/contact">Contact us</Link>
              </li>
            </ul>
          </nav>
        </div>
      </main>

      <Footer />
    </>
  );
}
